<script setup>
import { useAppStore } from '@/store/modules/app'
import { useUserStore } from '@/store/modules/user'
// import { getAccessToken } from '@/services/utils/auth'

const appStore = useAppStore()
const userStore = useUserStore()

onLaunch(() => {
    console.log('App Launch')
    setSystemInfo()

    wx.login({
        success(res) {
            if (res.code) {
                //发起网络请求
                console.log(res.code)
            } else {
                console.log('登录失败！' + res.errMsg)
            }
        }
    })
})

onShow(() => {
    console.log('App Show')
})

onHide(() => {
    console.log('App Hide')
})

async function setSystemInfo() {
    const systemInfo = uni.getSystemInfoSync()
    console.log(systemInfo)
    appStore.setSystemInfo(systemInfo)
}
</script>

<style lang="scss">
@use '@/assets/styles/font.css';
@use '@/assets/styles/index.scss';

scroll-view {
    -webkit-overflow-scrolling: touch;
}

scroll-view ::-webkit-scrollbar {
    width: 0;
    height: 0;
    background-color: transparent;
}

.uni-scroll-view::-webkit-scrollbar {
    display: none;
}

/* 禁止页面整体滚动回弹效果 */
// html,
// body {
//     overscroll-behavior: none;
//     touch-action: none;
// }
</style>
